import { IS_SMALL_SCREEN, NOT_SMALL_SCREEN } from './types';

export const isSmallScreen = isSmallScreenConst => async dispatch => {
  if (isSmallScreenConst) {
    dispatch({ type: IS_SMALL_SCREEN });
  } else {
    dispatch({ type: NOT_SMALL_SCREEN });
  }
};
